export default {
  view: {
    back: {
      title1: 'We have accepted the transaction for processing!',
      title2: 'Thank you for being with us!',
      buttonTopup: 'Top up again',
      buttonBack: 'Continue'
    },
    backCreditCard: {
      title1: 'Your payment card has been verified!',
      title1a: 'BLIK recurring payment has been enabled',
      title2: 'Subsequent top-up payments will be collected automatically.',
      titleVerify: 'Payment is being processed',
      titleError: 'Payment could not be processed!',
      buttonBack: 'Next',
      blikDescription: 'Confirm and create a recurring payment in your bank\'s app.'
    },
    contacts: {
      header: 'Contacts'
    },
    unregister: {
      loading: 'Wait a moment. The&nbsp;declaration is&nbsp;being&nbsp;verified...',
      title1ok: 'Thank you for reporting.',
      title2ok: 'Your contact has been deleted.<br>You will not receive such messages.<br>Greetings!',
      title1error: 'Oops... Something went wrong.',
      title2error: 'Try to delete the subscription again.',
      buttonTopup: 'Top up your phone'
    },
    userTerms: {
      loading: 'Processing data...',
      header: 'Accept the account terms and conditions',
      fieldTermsAgree: 'I have read and agree to the <a href="/files/plus/Regulamin-prowadzenia-konta-PLUS_en.pdf" target="_blank">Terms of payment service</a> maintaining an account on the website doladuj.plus.pl and the <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer">Privacy Policy</a>',
      required: 'Required field',
      rodoText: 'The controller of the personal data is Autopay S.A. 6 Powstańców Warszawy Street, 81-718 Sopot. Providing personal data is voluntary, but necessary to complete the payment. Legal basis, purpose, period of personal data processing and User\'s rights as well as other important information concerning the principles of personal data processing are defined in detail in <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer">the Autopay S.A. Privacy Policy</a>',
      buttonNext: 'Next',
      messges: {
        setTermsSuccess: 'The consent to the regulations has been correctly saved!',
        setTermsError: 'An error occurred while trying to save consent to the terms and conditions!'
      }
    },
    history: {
      header: 'Top-up history'
    },
    userData: {
      header: 'My data'
    }
  },
  component: {
    cookie: {
      text: 'I consent to the storage of cookies on my device.',
      button: 'OK'
    },
    header: {
      linkLogin: 'Sign in',
      title: 'Plus Online top-up',
      loading: 'Downloading data...',
      linkTopup: 'Top up',
      linkHistory: 'History',
      linkContacts: 'Contacts',
      linkMyData: 'My data',
      linkLogout: 'Log out',
      a11y: {
        skipButton: 'Skip to main content',
        hamburgerButton: 'Show navigation view',
        closeButton: 'Hide navigation view',
        languages: {
          pl: 'Change language to Polish',
          en: 'Change language to English',
          uk: 'Change language to Ukrainian'
        },
        nav: {
          main: 'Go to the main page',
          linkTopup: 'Go to the top-up page',
          linkHistory: 'Go to the top-up history page',
          linkContacts: 'Go to the contacts page',
          linkMyData: 'Go to the My data page',
          linkLogout: 'Log out user'
        }
      }
    },
    autotopup: {
      progress: {
        step1: 'Top-up type',
        step2: 'Phone number',
        step3: 'Activation'
      },
      start: {
        header: 'Select the top-up type',
        topupSingle: 'Disposable <span class="no-wrap">top-up</span>',
        topupAuto: 'Cyclic top-up',
        errorTypeRequired: 'Select the top-up type',
        buttonNext: 'Next',
        a11y: {
          nav: {
            topupTypeSingle: 'Go to the page with the single top-up form',
            topupTypeAuto: 'Go to the page with the recurring top-up form'
          }
        }
      },
      stage1: {
        title: '<strong>Step 1</strong> - top-up type',
        header: 'Choose top-up conditions',
        errorTypeRequired: 'Choose top-up conditions',
        periodLabel: 'How many days do you want to receive a top-up?',
        dayLabel: 'Top-up day',
        buttonNext: 'Next',
        fieldAmountLabel1: 'Top-up amount',
        fieldAmountLabel2: 'PLN',
        fieldPeriodLabel1: 'every',
        fieldPeriodLabel2: 'days starting from',
        fieldPeriodPlaceholder: 'date',
        fieldTopupDayLabel1: 'every',
        fieldTopupDayLabel2: 'day of the month',
        errorAmountRequired: 'Enter the amount of top-up',
        errorPeriodRequired: 'Enter the top-up period',
        errorNextTopupDayRequired: 'Enter the top-up date',
        a11y: {
          toNextStepButton: 'Go to the second step in a new view'
        }
      },
      stage2: {
        title: '<strong>Step 2</strong> - phone number',
        headerNoContacts: 'Add top-up number',
        header1: 'Choose a number from the list',
        header2: 'Or add a top-up number',
        contactCheckphoneError: 'The phone number cannot be topped up at the moment!',
        labelPhone: 'The phone number you want to top-up',
        errorPhoneRequired: 'The phone number is required',
        errorPhoneInvalid: 'The phone number is incorrect',
        errorPhoneCheck: 'The phone number can not be topped up',
        errorPhoneAutotopupActive: 'The phone number has already active cyclic top-up',
        labelName: 'Contact name',
        fieldNamePlaceholder: 'Contact name',
        errorNameRequired: 'The contact name is required',
        buttonNext: 'Next',
        buttonBack: 'Back',
        a11y: {
          toPreviousStepButton: 'Go to the first step in a new view',
          toNextStepButton: 'Go to the third step in a new view'
        }
      },
      stage4: {
        title: '<strong>Step 3</strong> - top-up activation',
        header: 'Summary',
        creditCardInfo: 'In a moment, we will ask you for the addition of a payment card, from which we will collect the amount you chosen. Prepare the necessary data: card number, validity date and CVV / CVC code.',
        blikInfo: 'In a moment, we will ask you to activate BLIK recurring payment. Generate a 6-digit BLIK code in your banking application.',
        summaryHeader: 'Check if the following data is correct.',
        topupInfoLabel: 'Information about top-up',
        topupInfoType1Label: 'Top-up type',
        topupInfoType1Text: 'Cyclic top-up',
        topupInfoType2Label: 'Top-up principle',
        topupInfoType2Text: 'Based on the date',
        topupInfoAmountLabel: 'Top-up amount',
        topupInfoDayLabel: 'Top-up day',
        topupInfoPeriodLabel: 'Top-up period',
        topupInfoPeriodText: 'every {day} days',
        topupInfoNextDateLabel: 'Top-up date',
        topupContactLabel: 'Contact data',
        topupContactPhoneLabel: 'Phone number',
        topupContactNameLabel: 'Name',
        agreementErrorHeader: 'Error download Regulations Services',
        agreementErrorMessage: 'Sorry, but for technical reasons, the service regulations could not be downloaded. Try again for some time.',
        agreementText: '<span class="red">*</span> I have read and agree to the <a href="{regulationUrl}" target="_blank">Terms and Conditions for Automatic Phone Top-Ups</a> and the <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer">Privacy Policy</a>.',
        paymentText: '<span class="red">*</span> I wish the service to be provided immediately and I acknowledge that I will not be reimbursed for any costs incurred in the event of withdrawal from the contract.',
        termsText: '<span class="red">*</span> I consent to Autopay S.A. periodically charging my payment card in fixed amounts resulting from the selected denomination of the phone top-up, in accordance with the <a href="{regulationUrl}" target="_blank">Regulations for automatic phone top-ups</a>. The payment card will be charged with the frequency selected by me on the [name of the service] website, until I resign from the periodic charging of the card. I acknowledge that I am entitled to resign from the periodic charging of the payment card in the manner specified in the <a href="{regulationUrl}" target="_blank">Regulations for automatic phone top-ups</a>. In case of any queries related to automatic top-ups, please contact the Autopay S.A. Customer Service Department. in the manner indicated in the <a href="{regulationUrl}" target="_blank">Regulations for automatic phone top-ups</a>.',
        required: 'Required field',
        buttonNext: 'Next',
        buttonBack: 'Back',
        paymentMethodCard: 'Payment card',
        paymentMethodBlik: 'BLIK recurring payments',
        messges: {
          addTopupErrorHeader: 'Error!',
          addTopupError: 'You could not save cyclic top-up!',
          addTopupSuccess: 'Cyclic top-up saved!'
        },
        a11y: {
          toPreviousStepButton: 'Go to the second step in a new view',
          submitButton: 'Go to the new payment page'
        }
      }
    },
    blik: {
      header: 'BLIK recurring payments',
      loadingText: 'Loading data...',
      verifyText1: 'To activate recurring BLIK payments, enter the 6-digit BLIK code from your bank\'s application.',
      verifyText2: 'Now you will pay 1 PLN so that we can enable recurring BLIK payments. We will refund you this amount later.',
      descriptionText: 'To complete this order, we need your data. By clicking "Pay", you decide to provide it to us. The administrator of your personal data is Autopay with its registered office in Sopot, ul. Powstańców Warszawy 6, 81-718. Information on the legal basis, purpose and period in which we will store your data and the rights that you (as a User) are entitled to can be found in <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Autopay S.A. Privacy Policy</a>',
      blikDescription: 'You activate "Recurring BLIK payments" for your account. You can use this payment method to pay for recurring top-ups. You set the amount and frequency of recurring top-up fees yourself. You can enable them for any phone number saved in the service - now or in the future. You can activate BLIK recurring payments in the following banks:',
      labelBlik: 'Enter the BLIK code',
      placeholderBlik: 'BLIK code',
      buttonNext: 'Pay',
      errorFieldRequired: 'Required field',
      errorFieldPattern: 'The BLIK code must consist of 6 digits',
      errorBankNotSupported: 'You cannot enable BLIK Recurring Payment because this service is not supported by your bank. Check the list of available banks.',
      summary: {
        nameLabel: 'Name',
        nameValue: 'recurring payment',
        amountLabel: 'Top-up amount',
        amountValue: 'any',
        frequencyLabel: 'Frequency',
        frequencyValue: 'any',
        payLabel: 'Now you will pay',
        payValue: '1 PLN'
      },
      messges: {
        addTokenSuccessHeader: 'Success!',
        addTokenSuccess: 'Your BLIK Recurring Payment is being processed. It will be visible in the My Details section in a moment.',
        addTokenErrorHeader: 'Error!',
        addTokenError: 'BLIK save failed!'
      }
    },
    creditcard: {
      header: 'Credit card',
      loadingText: 'Data loading...',
      verifyText: 'In order to verify the card, we will charge your account with the amount of PLN 1, and when the verification is successful, we will refund it.',
      iframeValidationError: 'The given data is incorrect',
      iframeValidationSuccess: 'The given data is correct',
      descriptionText: 'To realize this order, we need your data. By clicking "Pay", you decide to give us them. The administrator of your personal data is Autopay with its registered office Powstańców Warszawy 6, 81-718 Sopot. Information on the legal basis, purpose and the period in which we will store your data and permissions that you are entitled to (as a user), find in <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank">Autopay SA privacy policies</a>',
      buttonNext: 'Pay',
      messges: {
        addTokenErrorHeader: 'Error!',
        addTokenError: 'You could not save the card data!'
      }
    },
    progress: {
      step1: 'Phone number and <span>e-mail</span>',
      step2: 'Top-up amount',
      step3: 'Summary and&nbsp;payment'
    },
    stage1: {
      formErrorHeader: 'Complete all required fields of the form!',
      formErrorPhone: 'Enter at least one phone number to top up.',
      formErrorEmail: 'Please enter a valid e-mail address.',
      formErrorCheckphone: 'Number {phone} cannot be topped up.',
      title: '<strong>Step 1</strong> - Phone number and e-mail',
      header: 'Provide your phone number and e-mail address',
      labelPhone: 'Phone number you want to top up',
      errorPhoneRequired: 'Phone number is required',
      errorPhoneInvalid: 'Phone number is incorrect',
      errorPhoneCheck: 'Phone number cannot be topped up',
      labelEmail: 'E-mail address',
      placeholderEmail: 'enter your e-mail address',
      errorEmailRequired: 'E-mail address is required',
      errorEmailInvalid: 'E-mail address is incorrect',
      emailDescription: 'We will send you a top-up confirmation to this e-mail address.',
      addPhone: 'Add another number',
      addPhoneMaxInfo: '(max. {count} numbers)',
      required: 'fields required',
      buttonNext: 'Continue',
      maintenanceHeader1: 'A technical break is underway.',
      maintenanceHeader2: 'We invite you on 28.05.2020 from 08:00.',
      headerLogged1: 'Select a number from the list',
      headerLogged2: 'or enter the top-up number',
      loadingText: 'Downloading data...',
      contactCheckphoneError: 'The phone number cannot be topped up at the moment!',
      a11y: {
        addNumberButton: 'Show next field for entering phone number',
        removeNumberButton: 'Remove phone number field',
        chooseNumberButton: 'Select this phone number',
        unselectNumberButton: 'Unselect this phone number'
      }
    },
    stage2: {
      title: '<strong>Step 2</strong> - Amount of top-up',
      header: 'Select the top-up amount for the number <span>{phone}</span>',
      headerLogged: 'Top up amount for <span>{contactName}</span>',
      advTitle: 'Get an extra top-up!',
      advText: 'Top up your account 4 times with any amount and you will get extra bonus funds',
      advLink: 'Terms and Conditions of Promotion',
      recommend: 'Recommended!',
      otherAmount: 'other<br>amount',
      messageAmountMin: 'The specified amount has been changed because the minimum top-up amount is PLN <strong>{amount}</strong>.',
      messageAmountMax: 'The specified amount has been changed because the maximum top-up amount is PLN <strong>{amount}</strong>.',
      buttonBack: 'Return',
      buttonNext: 'Continue',
      saveContact: 'Add to address book',
      setReminder: 'Remind about recharging',
      setReminderIn: 'in',
      setReminderDays: 'days',
      placeholderContactName: 'contact name',
      a11y: {
        advLink: 'Go to the pdf document with the Top-up Regulations'
      }
    },
    stage3: {
      title: '<strong>Step 3</strong> - Summary and payment',
      header: 'Summary',
      loadingText: 'Processing data...',
      topupErrorHeader: 'An error has occurred while processing the top-up!',
      topupErrorText: 'Try again or consult technical support.',
      labelPhone: 'Phone number',
      labelAmount: 'Amount',
      labelEmail: 'Email address',
      checkAll: 'Tick all consents',
      agreementText: '<span class="red">*</span> I have read and accept the <a href="/files/plus/Regulamin-doladowan-PLUS_en.pdf" target="_blank" rel="noreferrer" title="Go to the page with the pdf document PLUS Top-up Regulations">Terms and Conditions for Mobile Phone Top-Ups</a> and <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer" title="Go to page with pdf document Privacy Policy">Privacy&nbsp;policy</a>',
      paymentText: '<span class="red">*</span> I want the service to be performed promptly, and I understand that if the service is fully performed, I will lose my right to cancel the contract as soon as it is performed.',
      marketingText: 'I want to receive from Autopay S.A. or from its Partners email or telephone information on promotions, competitions and other interesting events organized by Autopay. I know that Autopay will not spam me with redundant information and that I can withdraw my consent at all times.',
      rodoText: 'The Personal Data Controller is Autopay S.A., ul. Powstańców Warszawy 6, 81-718 Sopot. The provision of personal data is voluntary but necessary for the processing of payment. The legal basis, purpose, period of personal data processing and the rights of the User, as well as other important information concerning the principles of personal data processing are specified in detail in the <a href="https://autopay.eu/storage/app/media/Autopay_pl/Dokumenty/privacy_policy.pdf" target="_blank" rel="noreferrer" title="Go to page with pdf document Privacy Policy">Privacy Policy of Autopay S.A.</a>',
      buttonBack: 'Return',
      buttonNext: 'Order and pay',
      required: 'required field'
    },
    footer: {
      linkTerms: 'Terms and Conditions',
      linkTermsPromo1: 'Promotion Rules "4 doładowania i gratis"',
      linkTermsAuto: 'Regulations of recurring top-ups',
      linkInvoice: 'Invoice for top-up',
      linkFaq: 'Frequently asked questions',
      registerSim: 'Register the SIM card',
      copyrights: '© {year} Polkomtel Sp. z o.o. All rights reserved',
      menu: {
        linkAboutUs: 'About Us',
        linkContact: 'Contact',
        linkPress: 'Press',
        linkNews: 'News',
        linkJob: 'Jobs',
        linkPrivacyPolicy: 'Privacy Policy',
        linkSiteMap: 'Site map'
      }
    },
    contacts: {
      loadingText: 'Downloading data...',
      addContact: 'Add contact',
      form: {
        labelName: 'Name',
        errorName: 'Contact name is required',
        labelPhone: 'Phone number',
        errorPhoneRequired: 'Phone number is required',
        errorPhoneInvalid: 'Phone number is incorrect',
        errorPhoneCheck: 'Phone number cannot be topped up',
        errorPhoneNotUnique: 'The phone number is already in Contacts',
        tooltipButtonSave: 'Save',
        tooltipButtonCancel: 'Cancel'
      },
      list: {
        emptyText: 'No data',
        labelName: 'Name',
        labelPhone: 'Phone number',
        labelAutotopup: 'Cyclic top-up',
        labelPaymentMethod: 'Payment method',
        paymentMethodBlik: 'BLIK',
        paymentMethodCard: 'Credit card',
        tooltipButtonEdit: 'Edit',
        tooltipButtonDelete: 'Remove',
        tooltipButtonTopup: 'Top up',
        topupPeriodConditions: '{amount} PLN every {day} days',
        topupPeriodNextDate: 'Top-up date:',
        topupDayConditions: '{amount} PLN every {day} day of the month',
        topupButtonAdd: 'Click to add',
        a11y: {
          topupButtonAdd: 'Go to top-up configuration page',
          topupButton: 'Go to top-up page',
          topupButtonEdit: 'Open contact edit view'
        }
      },
      messges: {
        removeHeader: 'Alert!',
        removeConfirm: 'Are you sure you want to delete the contact?',
        removeConfirmButton: 'Delete',
        removeCancelButton: 'Cancel',
        removeSuccess: 'Contact has been deleted!',
        removeError: 'The contact could not be deleted.',
        phoneVerifyHeader: 'Error!',
        phoneVerifyError: 'An error occurred while verifying the phone number.',
        addContactSuccess: 'The contact has been added.',
        addContactErrorHeader: 'Error!',
        addContactError: 'The contact could not be added.',
        updateContactSuccess: 'Contact has been updated.',
        updateContactErrorHeader: 'Error!',
        updateContactError: 'Contact failed to update.'
      }
    },
    contactsEdit: {
      header: 'Contact edit',
      buttonBack: 'Cancel',
      buttonNext: 'Save',
      buttonPaymentTypeBlik: 'BLIK',
      buttonPaymentTypeCard: 'Credit card',
      autotopupHeader: 'Cyclic top-up',
      paymentMethodHeader: 'Payment type',
      contactButtonDelete: 'Delete contact',
      autotopupButtonDelete: 'Remove cyclic top-up',
      autotopupButtonAdd: 'Add cyclic top-up',
      messges: {
        updateAutotopupSuccess: 'Your cyclic top-up has been updated!',
        updateAutotopupError: 'We could not update the cyclic top-up data!',
        removeHeader: 'Attention!',
        removeConfirm: 'Is it sure to remove cyclic top-up?',
        removeConfirmButton: 'Remove',
        removeCancelButton: 'Cancel',
        removeSuccess: 'Your cyclic top-up has been removed!',
        removeError: 'The cyclic top-up could not be removed.',
        updateContactSuccess: 'Contact has been updated!',
        updateContactError: 'Could not update contact details!'
      },
      a11y: {
        autotopupButtonAdd: 'Go to top-up configuration page',
        buttonBack: 'Cancel changes and go to contacts page',
        buttonNext: 'Save changes and go to contacts page',
        buttonPaymentTypeCard: 'Select payment card as payment type',
        buttonPaymentTypeBlik: 'Select Blik as payment type'
      }
    },
    history: {
      filter: {
        labelDateStart: 'Starting date',
        labelDateEnd: 'End date',
        errorDateStart: 'Enter a valid start date',
        errorDateEnd: 'Enter a valid end date',
        buttonSearch: 'Search'
      },
      list: {
        emptyText: 'No data in the top-up history',
        labelPaymentDate: 'Date',
        labelTopupAmount: 'Amount',
        labelTopupType: 'Type',
        labelPhoneNumber: 'Phone',
        labelPaymentId: 'ID',
        labelPaymentStatus: 'Status',
        labelTopupStatus: 'Top-up',
        paymentStatusOk: 'paid',
        paymentStatusWait: 'pending',
        paymentStatusError: 'payment error',
        topupStatusOk: 'realized',
        topupStatusWait: 'awaiting',
        topupStatusError: 'top-up error',
        tooltipTopupAgain: 'Top up again',
        tooltipTopupSingle: 'Disposable top-up',
        tooltipTopupAuto: 'Cyclic top-up',
        a11y: {
          pageSizeSelect: 'Change the number of records displayed',
          topupButton: 'Go to top-up page'
        }
      }
    },
    userData: {
      account: {
        header: 'User\'s account',
        labelEmail: 'E-mail:',
        labelPassword: 'Password:',
        buttonRemoveAccount: 'Delete',
        messages: {
          removeHeader: 'Attention!',
          removeConfirm: 'Are you sure you want to delete your account?',
          removeConfirmButton: 'Delete',
          removeCancelButton: 'Cancel',
          removeSuccess: 'Your account has been deleted.',
          removeError: 'You could not delete account!'
        },
        a11y: {
          buttonEditAccount: 'Go to user data editing view'
        }
      },
      payment: {
        header: 'Recurring payment methods',
        description: 'Add a payment method to pay for recurring top-ups. You can remove payment methods or change the way recurring top-ups are paid for individual phone numbers at any time. If you do not have an active payment method, the recurring top-up service is disabled.',
        labelStatus: 'Status:',
        labelType: 'Type:',
        labelCardNumber: 'The card number',
        labelCardValidity: 'Expiration date:',
        creditCardType: 'Credit card',
        blikType: 'BLIK',
        blikValidity: 'indefinitely',
        blikNumber: 'not applicable',
        statusActive: 'ACTIVE',
        statusInactive: 'INACTIVE',
        statusPending: 'ACTIVATION',
        statusFailure: 'ACTIVATION ERROR',
        buttonAddCreditCard: 'Add a payment card',
        buttonAddBlik: 'Add BLIK payment',
        buttonRemoveCreditCard: 'Delete',
        buttonRemoveBlik: 'Delete',
        messages: {
          removeHeader: 'Attention!!',
          removeConfirm: 'Are you sure you want to remove your payment card? Without a payment card, cyclic top-ups can not be implemented.',
          removeConfirmButton: 'Remove',
          removeCancelButton: 'Cancel',
          removeSuccess: 'The payment card has been removed.',
          removeError: 'You could not remove the payment card!'
        }
      }
    }
  },
  globalMessages: {
    userSessionTimeOut: 'For security reasons, you have been automatically Logged out. Please login again.'
  }
}
